import React from 'react';
import { StarIcon } from 'lucide-react';
import { presets } from '../data/presets';
import { formatDkk } from '../utils/format';
interface PresetBarProps {
  activeId: string | null;
  onSelect: (id: string) => void;
}
export function PresetBar({
  activeId,
  onSelect
}: PresetBarProps) {
  const anchor = presets.find(p => p.recommended);
  const alternatives = presets.filter(p => !p.recommended);
  return <div data-id="element-129" data-mp="1v7w6v2a578qt">
      {anchor ? <button type="button" aria-pressed={anchor.id === activeId} onClick={() => onSelect(anchor.id)} className={['w-full rounded-card border bg-ink-850 px-6 py-5 text-left transition-colors duration-150 ease-out lg:px-7', anchor.id === activeId ? 'border-security/70' : 'border-line hover:border-security/50'].join(' ')} data-id="element-130" data-mp="1v8xlthua4fdt">
          <div className="flex flex-wrap items-start justify-between gap-x-8 gap-y-3" data-id="element-131" data-mp="3bm5mn80bjp61">
            <div className="max-w-xl" data-id="element-132" data-mp="1wj1xyqs3j0ax">
              <span className="flex items-center gap-2" data-id="element-133" data-mp="1wi0kygris3qk">
                <StarIcon className="h-3.5 w-3.5 text-security" aria-hidden="true" data-id="element-134" data-mp="21i53sdfwhajy" />
                <span className="text-[11px] font-medium uppercase tracking-[0.18em] text-security" data-id="element-135" data-mp="1nj5c0wx3cfjk">
                  Where we would start
                </span>
              </span>
              <span className="mt-2 block text-xl font-semibold tracking-tight text-paper" data-id="element-136" data-mp="2f91jj3oq9x9l">
                {anchor.name}
              </span>
              <span className="mt-1.5 block text-sm leading-relaxed text-paper-muted" data-id="element-137" data-mp="2k84qwus6kfkq">
                {anchor.tagline}
              </span>
            </div>
            <div className="tnum flex shrink-0 items-center gap-6 lg:gap-8" data-id="element-138" data-mp="2aibbfiox3gb7">
              <span className="block" data-id="element-139" data-mp="2y8fiy158807h">
                <span className="block text-xs uppercase tracking-[0.14em] text-paper-dim" data-id="element-140" data-mp="2y7coxkclxhnc">
                  Fixed
                </span>
                <span className="mt-1 block text-lg font-semibold text-paper" data-id="element-141" data-mp="3318miloyl2hz">
                  {formatDkk(anchor.fixedMonthly)}
                </span>
              </span>
              <span className="block" data-id="element-142" data-mp="38u0z36i81z7w">
                <span className="block text-xs uppercase tracking-[0.14em] text-paper-dim" data-id="element-143" data-mp="33ufzctv89mu4">
                  Commission / equity
                </span>
                <span className="mt-1 block text-lg font-semibold text-paper" data-id="element-144" data-mp="2yujw4wuctzfm">
                  {Math.round(anchor.commissionShare * 100)}
                  {' / '}
                  {100 - Math.round(anchor.commissionShare * 100)}
                </span>
              </span>
            </div>
          </div>
        </button> : null}

      <p className="mt-6 text-[11px] uppercase tracking-[0.18em] text-paper-dim" data-id="element-145" data-mp="2l1kfgriu5z6h">
        Or move the anchor
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2 lg:grid-cols-4" data-id="element-146" data-mp="2b5hevq3mu8ln">
        {alternatives.map(preset => {
        const active = preset.id === activeId;
        return <button key={preset.id} type="button" aria-pressed={active} onClick={() => onSelect(preset.id)} className={['rounded-lg border px-4 py-3 text-left transition-colors duration-150 ease-out', active ? 'border-paper/60 bg-ink-800' : 'border-line bg-ink-900 hover:border-paper-dim'].join(' ')} data-id="element-147" data-mp="2690he5ajmhvw">
              <span className="block text-sm font-medium text-paper" data-id="element-148" data-mp="1ddsxmpvui2l3">
                {preset.name}
              </span>
              <span className="mt-0.5 block text-xs leading-snug text-paper-dim" data-id="element-149" data-mp="1i984gxvfqy80">
                {preset.tagline}
              </span>
            </button>;
      })}
      </div>
    </div>;
}